import { GetStaticProps } from 'next';
import { AuthorPostListPage } from '../../../components/Author/AuthorPostsListPage';
import {
  IGET_AUTHOR_POST_LAYOUT,
  IParams,
} from '../../../components/Author/types';
import {
  getStaticPathsData,
  getStaticPropsAuthorPostData,
} from '../../../components/Author/utils/authorPostListUtils';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';

const AuthorsDetailPage = ({
  authorName,
  data,
}: IGET_AUTHOR_POST_LAYOUT): JSX.Element => {
  return <AuthorPostListPage data={data} authorName={authorName} />;
};

export default AuthorsDetailPage;

export const getStaticPaths = () => {
  if (process.env.DEPLOYMENT_DOMAIN !== 'cleartax.in') {
    return { paths: [], fallback: false };
  }
  return getStaticPathsData();
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  ({ params }: IParams) => getStaticPropsAuthorPostData({ params })
);
